import { useCallback } from 'react';

import { useAnalyticsService } from '@/app/providers/analytics-service/hooks';

import { useAgeVerification } from '@/features/age-verification/use-age-verification';

import { useGamesActions } from '@/shared/store/games-store/games-store';
import { type ImpressionContext } from '@/shared/store/games-store/types';

export { type ImpressionContext } from '@/shared/store/games-store/types';

export const usePlayGame = () => {
  const analyticsService = useAnalyticsService();
  const { isAgeConfirmed, openAgeConfirmation } = useAgeVerification();
  const { playClick } = useGamesActions();

  type PlayClickArgs = Parameters<typeof playClick>;

  return useCallback(
    (
      game: PlayClickArgs[0],
      source: PlayClickArgs[1],
      placementNum?: number,
      impressionContext?: ImpressionContext
    ) => {
      if (!game) return;

      if (game.flags?.adult) {
        if (isAgeConfirmed) {
          playClick(game, source, analyticsService, placementNum, impressionContext);
        } else {
          openAgeConfirmation({
            onConfirm: () =>
              playClick(game, source, analyticsService, placementNum, impressionContext),
          });
        }
        return;
      }

      return playClick(game, source, analyticsService, placementNum, impressionContext);
    },
    [analyticsService, isAgeConfirmed, openAgeConfirmation, playClick]
  );
};
